import '../../monitoring/filters/tag/applied_tags_view.js.coffee'
Namespace 'Surveys.Views.Filters'

class Surveys.Views.Filters.AppliedTagsView extends Monitoring.Views.SocialContents.Filters.AppliedTagsView

  _filterName: ->
    I18n.t('surveys.dashboard.filters.tags')
